const AlertLevelMap = {
  "-1": { name: "未绑定回路" },
  "0": { name: "设备新装" },
  "1": { name: "运行正常" },
  "2": { name: "早期异常" },
  "3": { name: "中期隐患" },
  "4": { name: "危险隐患" },
  "95": { name: "触电风险" },
  "96": { name: "设备较大隐患" },
  "97": { name: "劣质用电设备" },
  "98": { name: "电气线路触电隐患" },
  "99": { name: "零地混接" },
  "100": { name: "接线不规范" },
  "101": { name: "线路老化" },
  "102": { name: "接触电阻过大" },
  "103": { name: "早期短路" },
  "104": { name: "严重短路" },
  "105": { name: "零线绝缘破损" },
  "106": { name: "单相失压" },
  "107": { name: "均衡老化" },
  "108": { name: "故障电弧" },
  "109": { name: "早期电弧" },
  "110": { name: "运行异常" },
  "111": { name: "运行风险" },
  "112": { name: "运行较大风险" },
  "113": { name: "运行严重风险" },
  "114": { name: "谐波干扰源" },
  "115": { name: "严重谐波干扰源" },
  "116": { name: "零地反接" },
  "120": { name: "漏电异常" },
  "121": { name: "用电异常" },
  "122": { name: "电动车充电违规异常" },
  "123": { name: "早期线路老化" },
  "124": { name: "严重线路老化" },
  "125": { name: "早期漏电异常" },
  "126": { name: "严重漏电异常" },
  "200": { name: "监测中" },
}


const AlertLevel = {
  get(code, key) {
    const strCode = String(code);
    return (AlertLevelMap[strCode] && AlertLevelMap[strCode][key]);
  },
  name(code) {
    return this.get(code, 'name');
  },
  getOptions() {
    return Object.keys(AlertLevelMap).map(key => ({
      value: key,
      label: AlertLevelMap[key].name
    }));
  },
}

export default AlertLevel
